// extracted by css-extract-rspack-plugin
export default {"avatar":"LegacyCode-module__avatar__jnaD0"};